import {Container, Nav, Navbar} from "react-bootstrap";


const NavBarMenu = () => {
  return (
    <Navbar bg="dark" variant="dark">
      <Container>
        <Navbar.Brand href="#home">
          Nam Nguyen</Navbar.Brand>
        <Navbar.Toggle/>
        <Navbar.Collapse className="justify-content-end">
          <Nav>
            <Nav.Item>
              <Nav.Link href="/">About Me</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/">Recent Projects</Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default NavBarMenu;